import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../common';
import { PARSE_ALL_MESSAGE_TO_STRING_NUM_VARIABLE } from '../../parsing';

import {
  ActionUserInputNormalizer,
  ActionUserInputParseTextType,
  IActionUserInputParams
} from './client';

const createActionUserInputActualNameBase = (
  params:
    | { kind: ActionUserInputParseTextType.allMessage; target: string | null }
    | { kind: ActionUserInputParseTextType.pattern; expr: string }
): string => {
  return params.kind === ActionUserInputParseTextType.allMessage
    ? params.target || ''
    : params.expr;
};

export const createActionUserInputActualName: ActualNameCreator<
  IActionUserInputParams
> = ({ params }) => {
  return createActionUserInputActualNameBase(
    params.extraction.text.kind === ActionUserInputParseTextType.allMessage
      ? {
          kind: ActionUserInputParseTextType.allMessage,
          target:
            params.extraction.text.allMessageModel.formatSavingParams.target
              .value ||
            params.extraction.text.allMessageModel.commonSavingParams.target
              .value
        }
      : {
          kind: ActionUserInputParseTextType.pattern,
          expr: params.extraction.text.pattern.expr
        }
  );
};

export const normalizeActionUserInput: ActionUserInputNormalizer = (
  raw,
  stores
) => {
  const { text } = raw.params.extraction;

  const isAllMessage =
    text &&
    text.expr.includes(PARSE_ALL_MESSAGE_TO_STRING_NUM_VARIABLE) &&
    Object.keys(text.groups).length === 1 &&
    text.groups[PARSE_ALL_MESSAGE_TO_STRING_NUM_VARIABLE];

  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createActionUserInputActualNameBase(
          isAllMessage
            ? {
                kind: ActionUserInputParseTextType.allMessage,
                target:
                  text.groups[PARSE_ALL_MESSAGE_TO_STRING_NUM_VARIABLE].target
              }
            : {
                kind: ActionUserInputParseTextType.pattern,
                expr: text?.expr || ''
              }
        ),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
